export class SoundManager {
  static readonly shootName = 'shoot';
  static readonly shoot = require('@/assets/games/space-rescue/sounds/shoot.wav');
  static readonly killEnemyName = 'killEnemy';
  static readonly killEnemy = require('@/assets/games/space-rescue/sounds/invaderkilled.wav');
  static readonly explosionName = 'explosion';
  static readonly explosion = require('@/assets/games/space-rescue/sounds/explosion.wav');
}
